module.exports = __webpack_public_path__ + "img/technology-22.7cbdde86.png";